<template>
  <el-container class="alipay-tradebill" >
    
    <el-header class="header-style">
    <el-divider content-position="left">企业支付宝收款记录</el-divider>
    <el-row>
      <el-col :span="20">
        <el-select
          style="width:270px;"
          v-model="searchArr.merchant_order_no"
          filterable
          remote
          reserve-keyword
          placeholder="请输入商户订单号"
          size="mini"
          clearable
          :remote-method="searchRemoteTeadeBillMethod"
          :loading="searchLoading"
          @change="handleSearchTradeOrderNoChange"
        >
          <el-option
            v-for="searchSingleOrderNo in searchTradeOrderNo"
            :key="searchSingleOrderNo.id"
            :label="searchSingleOrderNo.merchant_no"
            :value="searchSingleOrderNo.merchant_no"
          >
          </el-option>
        </el-select>
        <el-popover placement="bottom-start" v-model="visible" width="450">
          <el-form :model="searchArr" ref="searchForm" label-width="100px">
            <el-form-item label="交易时间" prop="transfer_time">
              <el-date-picker
                v-model="searchArr.transfer_time"
                type="daterange"
                range-separator="至" size="mini"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                @change="pickerSuccessTimeDateChange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item style="text-align: right">
              <el-button @click="resetForm('searchForm')" size="mini"
                >重置</el-button>
              <el-button
                type="primary"
                @click="submitForm()"
                size="mini"
                >查询</el-button>
            </el-form-item>
          </el-form>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
      </el-col>
      <el-button style="float:right;" type="primary" size="mini" @click="downloadTradebill">数据同步</el-button>
      <!-- <el-button style="float:right;margin-right: .2rem;" type="primary" size="mini" @click="batchWithOrder">批量关联订单</el-button> -->
    </el-row>
  </el-header>

  <el-main class="main-style">
    <el-table
    height="calc(100vh - 276px)"
      :data="tradebillRecords"
      size="medium"
      border
      style="width: 100%;"
      v-cloak
    >
    <el-table-column label="账务流水号" width="160">
        <template slot-scope="scope">
          <div v-if="scope.row.account_no">
            <el-tooltip :content="scope.row.account_no" placement="top">
              <span class="count-style">{{ scope.row.account_no }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    <el-table-column label="业务流水号" width="160">
        <template slot-scope="scope">
          <div v-if="scope.row.business_no">
            <el-tooltip :content="scope.row.business_no" placement="top">
              <span class="count-style">{{ scope.row.business_no }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="商户订单号" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.merchant_no">
            <el-tooltip :content="scope.row.merchant_no" placement="top">
              <span class="count-style">{{ scope.row.merchant_no }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="商品名称" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.goods_name">
            <el-tooltip :content="scope.row.goods_name" placement="top">
              <span class="count-style">{{ scope.row.goods_name }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="交易时间" width="140">
        <template slot-scope="scope">
          <div v-if="scope.row.trade_date">
            <el-tooltip :content="scope.row.trade_date" placement="top">
              <span class="count-style">
              <!-- {{ scope.row.trade_date }} -->
              <date-formatter :date-value="scope.row.trade_date"></date-formatter>
              </span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收入金额" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.income_amount">
              <span class="count-style">{{ scope.row.income_amount }}</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="支出金额" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.outpay_amount">
            <el-tooltip :content="scope.row.outpay_amount" placement="top">
              <span class="count-style">{{ scope.row.outpay_amount }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column label="账户余额" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.acc_rest_amount">
              <span class="count-style">{{ scope.row.acc_rest_amount }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="业务类型" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.business_type">
              <span class="count-style">{{ scope.row.business_type }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="备注" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.remark">
            <el-tooltip :content="scope.row.remark" placement="top">
              <span class="count-style">{{ scope.row.remark }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </el-main>

  <el-footer class="footer-style">
    <el-pagination
      background
      class="tr mt-10"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </el-footer>

    <el-dialog title="选择同步日期" :visible.sync="dateChooseDrawer" width="30%">
        <el-form>
          <div>
            <el-form-item>
              <el-date-picker
                style="width: 420px;"
                v-model="trade_date"
                type="date"
                size="mini"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                @change="pickerDateChange"
                placeholder="选择同步时间">
              </el-date-picker>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" @click="confirmDownloadTradeBill">确定</el-button>
        </div>
    </el-dialog>
  </el-container>
</template>

<script>
import DateFormatter from "common/DateFormatter";
export default {
  name: 'AlipayTradeBill',
  components: {DateFormatter},
  data () {
    return {
      searchArr: {
        merchant_order_no: '',
        trade_status: '',
        transfer_time: '',
        transfer_start_time: '',
        transfer_end_time: ''
      },
      searchLoading: false,
      tradebillRecords: [],
      searchTradeOrderNo: [],
      visible: false,
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30 // 每页显示条数
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick: picker => {
              picker.$emit('pick', [new Date(), new Date()])
            }
          },
          {
            text: '昨天',
            onClick: picker => {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [date, date])
            }
          },
          {
            text: '本周',
            onClick: picker => {
              picker.$emit('pick', [this.thisWeek()[0], this.thisWeek()[1]])
            }
          },
          {
            text: '上周',
            onClick: picker => {
              picker.$emit('pick', [this.LastWeek()[0], this.LastWeek()[1]])
            }
          },
          {
            text: '本月',
            onClick: picker => {
              picker.$emit('pick', [this.thisMonth()[0], this.thisMonth()[1]])
            }
          },
          {
            text: '上个月',
            onClick: picker => {
              picker.$emit('pick', [this.LastMonth()[0], this.LastMonth()[1]])
            }
          }
        ]
      },
      dateChooseDrawer: false,
      trade_date: ''
    }
  },
  computed: {
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }
      return str
    },
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    // 批量关联订单
    batchWithOrder () {
      this.$axios
        .post('/api/qyh/alipay/batch_with_order')
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 同步账单
    downloadTradebill () {
      this.dateChooseDrawer = true
    },
    // 同步账单
    confirmDownloadTradeBill () {
      if (this.trade_date === '') {
        this.$message.error('请选择同步日期！')
        return false
      }
      this.$axios
        .post('/api/qyh/alipay/get_transfer_bill', {trade_date: this.trade_date}
        )
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.dateChooseDrawer = false
            this.trade_date = ''
            this.getTradebillRecords()
          } else {
            this.$message.error(data.msg)
            this.dateChooseDrawer = false
            this.trade_date = ''
          }
        })
    },
    // 列表
    getTradebillRecords () {
      this.$axios
        .get(
          '/api/admin/alipay/tradebill_index?page=' +
            this.pageOption.currentPage +
            "&pageSize=" +
            this.pageOption.pageSize + this.searchStr
        )
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.tradebillRecords = data.data.data.data
            this.pageOption.total = data.data.data.total
            this.pageOption.currentPage = data.data.data.current_page
          }
        })
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
      this.getTradebillRecords()
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getTradebillRecords()
    },
    searchRemoteTeadeBillMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchSingleTradeOrderNo(query)
        }, 200)
      } else {
        this.searchTradeOrderNo = []
      }
    },
    searchSingleTradeOrderNo (query) {
      this.$axios.get('/api/admin/alipay/searchTradeOrderNo?order_no=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchTradeOrderNo = data.data.searchTradeOrderNo
        }
      })
    },
    resetForm (formName) {
      this.visible = false
      this.$refs[formName].resetFields()
      this.pageOption.currentPage = 1
      this.getTradebillRecords()
    },
    submitForm () {
      this.visible = false
      this.pageOption.currentPage = 1
      this.getTradebillRecords()
    },
    handleSearchTradeOrderNoChange (val) {
      this.pageOption.currentPage = 1
      this.getTradebillRecords()
    },
    pickerDateChange (val) {
      if (!val) {
        this.trade_date = ''
      } else {
        this.trade_date = val
      }
    },
    pickerSuccessTimeDateChange (val) {
      if (!val) {
        this.searchArr.transfer_start_time = []
        this.searchArr.transfer_end_time = []
      } else {
        this.searchArr.transfer_start_time = val[0]
        this.searchArr.transfer_end_time = val[1]
      }
    },
    LastWeek () {
      const end = new Date()
      const start = new Date()
      const lastWeek = new Date().getDay() // 获取今日周几
      // 开始时间(上周一与今天间隔的天数)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 + lastWeek - 1)) // 减1是因为以下时间戳操作,例如周二,但是时间戳还在周一后的xx小时
      // 结束时间(上周末与今天间隔的天数)
      end.setTime(end.getTime() - 3600 * 1000 * 24 * lastWeek)
      return [start, end]
    },
    thisWeek () {
      var Nowdate = new Date()
      var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000)

      var M = Number(WeekFirstDay.getMonth()) + 1
      var start =
        WeekFirstDay.getFullYear() + '-' + M + '-' + WeekFirstDay.getDate()

      var WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000)
      var Mon = Number(WeekLastDay.getMonth()) + 1
      var end =
        WeekLastDay.getFullYear() + '-' + Mon + '-' + WeekLastDay.getDate()

      return [start, end]
    },
    thisMonth () {
      const end = new Date()
      const start = new Date()
      // 方法1
      const endDay = new Date().getDate() - 1 // 获取今日几号,减1是因为以下时间戳操作,例如今日16号,但是时间戳还在15号后的xx小时
      start.setTime(start.getTime() - 3600 * 1000 * 24 * endDay)
      // 方法2
      // start.setDate(1) //setDate(1)表示设置开始时间为本月1号,此办法同样可以实现
      return [start, end]
    },
    LastMonth () {
      const end = new Date()
      const start = new Date()
      const year = new Date().getFullYear() // 获取年份
      let month = new Date().getMonth() // 获取月份
      month = month === 0 ? 1 : month // 特殊处理:如果为1月 则下方取1月的天数
      const febDays = year % 4 ? 29 : 28 // 判断今年是否为闰年,如是则二月天数为29天,反之为28天
      let days = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31] // 罗列12个月的天数
      start.setDate(1 - days[month - 1]) // setDate(1)表表示设置为本月1号,故 本月1号 - 上月天数 = 上月1号
      end.setDate(1 - 1) // 以此得出,本月1号 - 1天 = 上月最后一天
      return [start, end]
    }
  },
  mounted () {
    this.getTradebillRecords()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.alipay-tradebill >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.alipay-tradebill {
  marginLeft();
  max-height: 100vh;
  .header-style {
    z-index: 2;
    height: 100px !important;
    padding: 0px !important;
  }
  .main-style {
    z-index: 1;
    padding: 0px !important;
    overflow-y: auto;
  }
  .footer-style {
    text-align: right;
    .el-pagination {
      padding-top: 20px;
    }
  }
  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.tr {
  text-align: right;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mt-20 {
  margin-top: 0.4rem;
}

.el-form-item {
  margin-bottom: 0.1rem;
}

.el-form .el-select {
  width: 100%;
}

.el-dialog .el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/alipay_tradebill/AlipayTradeBill.vue